import { useLocation, useNavigate } from 'react-router-dom';

const tabs = [
  { id: 'discovered', label: 'Discovered', path: '/monitoring/discovery' },
  { id: 'monitored', label: 'Monitored', path: '/monitoring/devices' },
  { id: 'network', label: 'Network', path: '/monitoring/network' },
];

const DevicesTabBar = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const getActiveTab = () => {
    if (location.pathname.startsWith('/monitoring/network')) return 'network';
    if (location.pathname.startsWith('/monitoring/discovery')) return 'discovered';
    return 'monitored';
  };

  const activeTab = getActiveTab();

  const listPages = ['/monitoring/discovery', '/monitoring/devices', '/monitoring/network'];
  if (!listPages.includes(location.pathname)) return null;

  return (
    <div className="devices-tab-bar">
      {tabs.map(tab => (
        <button
          key={tab.id}
          className={`devices-tab ${activeTab === tab.id ? 'active' : ''}`}
          onClick={() => navigate(tab.path)}
        >
          {tab.label}
        </button>
      ))}
    </div>
  );
};

export default DevicesTabBar;
